<template>
	<div class="comp-page" :class="{'comp-page-big': bigStyle}">
		<span @click="goFirstPage">首页</span>
		<span @click="goPrevPage">上页</span>
		<span v-for="pageNum in pageList" :class="{'comp-page-active': page == pageNum}" @click="goPage(pageNum)" v-if="!simple">{{pageNum}}</span>
		<span @click="goNextPage">下页</span>
		<span @click="goLastPage">末页</span>
	</div>
</template>
<script>
	
	export default{
		name:"PageComponent",
		props:{
			// 数据接口
			dataApi:{
				type: Function,
				required: true,
				default:function(){
					return
				}
			},
			// 是否为简洁类型分页
			simple: {
				type: Boolean,
				default: false
			},
			// 是否使用大尺寸的
			bigStyle:{
				type: Boolean,
				default: false
			},
			// 请求参数
			requestParams:{
				type: Object,
				default: function(){
					return {}
				}
			},
			autoInit: {
				type: Boolean,
				default: true
			},
			
		},
		data(){
			return{
				pages:1,
				page:1,
				prePage:10,
				pageSeries: 3,
				pageList:[]
			}
		},
		methods:{
			// 根据接口数据，初始化分页数据
			initPage(){
				this.page = 1
				// 获取数据-初始数据
				this.dataApi(this.requestParam(),data=>{
					let total = 0
					let back_data = []
					if(data.data !== undefined && data.total !== undefined){
						total = parseInt(data.total)
						back_data = data.data
					}
					this.pages = Math.ceil(total / this.prePage)
					this.pageNumList()
					this.$emit("page-call",back_data)
				})	
			},
			
			// 跳转到指定分页
			goPage(page){
				if(isNaN(parseInt(page))){
					return
				}
				if(page > this.pages || page < 1){
					return
				}
				this.page = page
				this.pageNumList()
				// 获取数据-仅仅是获取
				this.dataApi(this.requestParam(),data=>{
					this.$emit("page-call",data.data)
				})
			},
			
			// 跳转到指定分页-上一页
			goPrevPage(){
				if(this.page>1){
					this.goPage(this.page - 1)
				}
			},
			
			// 跳转到指定分页-下一页
			goNextPage(){
				if(this.page<this.pages){
					this.goPage(this.page + 1)
				}
			},
			
			// 跳转到指定分页-首页
			goFirstPage(){
				this.goPage(1)
			},
			
			// 跳转到指定分页-尾页
			goLastPage(){
				this.goPage(this.pages)
			},
			
			// 计算分页中间部分的数据展示
			pageNumList(){
				let pageList = []
				if(this.pages < 1){
					this.pageList = pageList
					return
				}
				// 小于连续分页*2时，直接显示所有
				if(this.pages <= this.pageSeries * 2){
					for (let i = 1; i <= this.pages; i++) {
						pageList.push(i)
					}
				}
				// 大于连续分页*2时，需要拆解分页码
				else{
					let leftNumList = []
					let centerNumList = []
					let rightNumList = []
					// 左侧分页填充
					for (let i = 1; i <= this.pageSeries; i++) {
						leftNumList.push(i)
					}
					// 右侧分页填充
					for (let i = this.pages; i > this.pages - this.pageSeries; i--) {
						rightNumList.unshift(i)
					}
					// 中部数据填充
					let centerOffset =  -Math.floor(this.pageSeries / 2) 
					for (let i = 0; i < this.pageSeries; i++) {
						let pageNum = this.page + i + centerOffset
						if(pageNum < 1 || pageNum > this.pages || leftNumList.indexOf(pageNum) !== -1 || rightNumList.indexOf(pageNum) !== -1){
							continue
						}
						centerNumList.push(this.page + i + centerOffset)
					}
					// 组合分页数据
					pageList = pageList.concat(leftNumList)
					if(centerNumList.length > 0){
						if(centerNumList[0]-1 !== leftNumList[leftNumList.length-1]){
							pageList.push("···")
						}
						pageList = pageList.concat(centerNumList)
						if(centerNumList[centerNumList.length-1]+1 !== rightNumList[0]){
							pageList.push("···")
						}
					}else{
						pageList.push(("···"))
					}
					pageList = pageList.concat(rightNumList)
				}
				this.pageList = pageList
			},
			
			// 请求参数合并
			requestParam(){
				this.requestParams.page = this.page
				if(this.requestParams.prePage === undefined){
					this.requestParams.prePage = this.prePage
				}else{
					this.prePage = this.requestParams.prePage
				}
				return this.requestParams
			}
		},
		mounted() {
			if(this.autoInit){
				this.initPage()
			}
		}
	}
</script>

<style>
	.comp-page{
		width: 100%;
		height: 26px;
		line-height: 26px;
		display: flex;
		justify-content: center;
		font-size: 12px;
		user-select: none;
	}
	.comp-page>span{
		display: block;
		border: 1px solid #e3e3e3;
		background-color: #f7f7f7;
		padding: 0 10px;
		margin: 0 2px;
		cursor: pointer;
		text-align: center;
		border-radius: 2px;
	}
	.comp-page .comp-page-active{
		color: #42B983;
		font-weight: 600;
		background-color: #d4f7e6;
		border: 1px solid #42B983;
	}
	.comp-page-big{
		height: 36px !important;
		line-height: 36px !important;
	}
	.comp-page-big > span{
		padding: 0 15px;
	}
</style>
